<template>
  <div :class="['site-banners', theme, !isOpenSizePanel ? 'close' : '']">
    <div class="site-wrapper">
      <div :class="['site-group']" v-for="(group, index) of sizes" :key="group.id">
        <div class="group-name" @click="openSizeGroup(group)">
          {{ group.groupName }}
          <i :class="['icon', { fold: group.isSelect }]"></i>
          <span class="selected-tips">已选中：{{ selectSizeCount[index].selectedCount }}</span>
        </div>
        <ul class="group-list" v-show="!group.isSelect">
          <li
            :class="['banner-item', { on: selectedSizeIds.includes(sizeItem.id) }, { exceed: sizeItem.isTextExceed }]"
            v-for="sizeItem of group.sizes"
            :key="sizeItem.id"
            @click="selectSize(sizeItem)"
          >
            <i
              :class="[
                'check-icon',
                'iconfont',
                {
                  'icon-jingshi': sizeItem.isTextExceed,
                  'icon-gouxuan': !sizeItem.isTextExceed && selectedSizeIds.includes(sizeItem.id),
                },
              ]"
            ></i>
            <span class="sizename_wrap" :style="{ color: sizeItem.isTextExceed ? '#f93434' : '' }"
              ><span class="sizename">{{ sizeItem.sizeName }}</span
              >&nbsp;&nbsp;<span>{{ sizeItem.width + "x" + sizeItem.height }}</span>
            </span>
            <el-popover
              placement="left"
              title="特殊尺寸"
              width="200"
              trigger="hover"
              content="该尺寸需要调整文字后下载使用。"
            >
              <i
                v-if="sizeItem.type"
                :class="['iconfont icon-wenti', { warn: sizeItem.isTextExceed }]"
                slot="reference"
              ></i>
            </el-popover>
          </li>
        </ul>
      </div>
    </div>
    <i
      class="sanjiao iconfont icon-zhan-shou"
      :class="[!isOpenSizePanel ? 'icon-zhan-shou_close' : '']"
      @click="isOpenSizePanel = !isOpenSizePanel"
    ></i>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "AiBannerRightnav",
  props: {
    theme: {
      type: String,
      default: "",
    },
    sizes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenSizePanel: true,
    };
  },
  mounted() {},
  computed: {
    ...mapState("banner", ["bannerDataList", "bannerData"]),
    selectSizeCount() {
      const arr = this.sizes.map(group => {
        return {
          id: group.id,
          total: group.sizes?.length || 0,
          selectedCount: group.sizes.reduce((sum, item) => {
            sum += this.selectedSizeIds.includes(item.id) ? 1 : 0;
            return sum;
          }, 0),
        };
      });
      return arr;
    },
    // 选中的站点
    selectedSizeIds() {
      return this.bannerDataList.map(banner => parseInt(banner.sizeId));
    },
  },
  methods: {
    openSizeGroup(group) {
      group.isSelect = !group.isSelect;
    },
    selectSize(sizeItem) {
      if (!this.selectedSizeIds.includes(sizeItem.id)) {
        this.$emit("addBannerSize", sizeItem);
      } else {
        this.$emit("removeBannerSize", sizeItem);
      }
    },
    // 选中的size的状态改变
    modifySizeState(bannerMap) {
      const { sizeId, isTextExceed } = bannerMap;
      for (let group of this.sizes) {
        const size = group.sizes.find(size => size.id === sizeId);
        if (size) {
          size.isTextExceed = isTextExceed;
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.site-banners {
  position: relative;
  box-sizing: border-box;
  width: 370px;
  background: #fff;
  transition: all 0.2s;
  padding-bottom: 85px;
  z-index: 99;
  .site-wrapper {
    height: 100%;
    overflow: auto;
    @include scroller;
  }
}
.close {
  width: 0;
  padding: 0;
}
.site-group {
  width: 300px;
  // max-height: 200%;
  padding: 5px 25px 0;
  cursor: pointer;
  transition: all 0.2s;
  .group-name {
    margin-bottom: 20px;
    color: #183b56;
    font-weight: 500;
    .icon {
      display: inline-block;
      border: 4px solid transparent;
      border-top: 4px solid #6d7278;
      transition: all 0.2s;
      &.fold {
        transform: translateY(-4px) rotate(180deg);
      }
    }
  }
  .group-list {
    overflow: auto;
  }
  .banner-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 23px;
    padding: 0 4px 0 22px;
    margin-bottom: 8px;
    font-size: 14px;
    border: 1px solid transparent;
    transition: all 0.1s;
    .check-icon {
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translate(0, -50%);
      width: 14px;
      height: 14px;
      border: 1px solid #6d7278;
      border-radius: 10px;
      margin-right: 4px;
      line-height: 18px;
      text-align: center;
      color: #fff;
    }
    .icon-jingshi {
      background: transparent;
      border-color: transparent;
      // transform: translateY(-3px);
      color: rgb(249, 52, 52);
      font-size: 14px;
      &::before {
        position: absolute;
        top: -2px;
        left: 0;
      }
    }
    .icon-gouxuan {
      border-color: #3f69f9;
      background-color: #3f69f9;
      line-height: 14px;
      font-size: 8px;
    }
    .sizename_wrap {
      display: flex;
      align-items: center;
      .sizename {
        display: inline-block;
        max-width: 130px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .icon-wenti {
      position: relative;
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-left: 3px;
      font-size: 14px;
      color: #75d1ff;
      &.warn {
        color: #f38a2d;
      }
    }
    &.on {
      border: 1px solid #3f69f9;
      border-radius: 10px;
      color: #3f69f9;
    }
    &.exceed {
      border: 1px solid #f93434;
      color: #f93434;
    }
  }
}
.icon-zhan-shou {
  position: absolute;
  top: 43vh;
  left: -36px;
  font-size: 55px;
  color: #3f69f9;
  cursor: pointer;
  &::after {
    content: "";
    position: absolute;
    top: 52%;
    left: 58%;
    transform: translate(-50%, -50%);
    display: inline-block;
    border: 6px solid transparent;
    border-left: 6px solid #fff;
  }
}
.icon-zhan-shou_close {
  &::after {
    left: 46%;
    transform: translate(-50%, -50%) rotate(180deg);
  }
}
.selected-tips {
  padding-left: 20px;
  font-size: 12px;
}
.error {
  border: 1px solid #f93434;
  color: #f93434;
  background-color: #f93434;
}
.dark.site-banners {
  width: 352px;
  background: transparent;
  padding-bottom: 120px;
  .site-group {
    width: auto;
    padding: 0;
    .banner-item {
      height: 40px;
      padding: 0 0 0 46px;
      border-radius: 8px;
      border-color: rgba(148, 131, 255, 0.3);
      background: #242931;
      color: #fff;
      .check-icon {
        left: 16px;
        width: 20px;
        height: 20px;
        font-size: 8px;
        color: #242931;
        line-height: 19px;
      }
      .icon-gouxuan {
        background: linear-gradient(295deg, #8569d9 0%, #4da9ff 100%);
        border: none;
      }
      &.on,
      &:hover {
        border-color: #8569d9;
        background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
      }
    }
    .group-name {
      color: rgba(255, 255, 255, 0.8);
    }
    &.group-fold {
      // max-height: 42px;
    }
  }
  .sanjiao {
    display: none;
  }
}
</style>
